var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33378 10.3333L8.00044 13M8.00044 13L10.6671 10.3333M8.00044 13V6.99996M13.9204 11.06C14.5 10.6524 14.9347 10.0707 15.1613 9.39939C15.3879 8.72805 15.3947 8.00197 15.1807 7.32651C14.9667 6.65104 14.543 6.06135 13.9712 5.643C13.3993 5.22464 12.709 4.9994 12.0004 4.99996H11.1604C10.9599 4.21854 10.5848 3.49279 10.0632 2.87734C9.54161 2.2619 8.88721 1.7728 8.14925 1.44686C7.41129 1.12092 6.60901 0.96664 5.80279 0.995633C4.99658 1.02463 4.20745 1.23614 3.49481 1.61424C2.78217 1.99234 2.16459 2.52719 1.68857 3.17851C1.21254 3.82983 0.890478 4.58065 0.746618 5.37445C0.602757 6.16826 0.64085 6.98435 0.85803 7.7613C1.07521 8.53825 1.46582 9.25581 2.00044 9.85996",
    stroke: "#505363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.0be6c05f44d0366f161dd1479bfc786b.svg";
export { ForwardRef as ReactComponent };